import coresCelula from '../Resolvers/coresCelula'
import {map, prop} from 'ramda'
import {path, isNil} from 'ramda'

export const fromApi = (celula, index) => {
  const labelsDescription = celula.labelsString.join(', ') || 'Sem Tags'

  return {
    ...celula,
    id: index,
    color: coresCelula(labelsDescription),
    labelsDescription,
    labels: celula.labelsString,
    igreja: {
      id: path(['igreja', 'id'], celula),
      descricao: path(['igreja', 'Igreja'], celula)
    }
  }
}

export const createCelulasPayload = celulas =>
  celulas.reduce((payload, celula, index) => {
    const transformed = fromApi(celula, index)
    payload.celulas.push(transformed)
    payload.labelsDescriptions[transformed.labelsDescription] = transformed.color
    if (!isNil(transformed.igreja.id)) {
      payload.igrejas[transformed.igreja.id] = transformed.igreja
    }
    return payload
  }, {celulas: [], labelsDescriptions: {}, igrejas: {}})





// WEBPACK FOOTER //
// ./src/Celula/transformers.js